import React, { Fragment } from 'react'
import { IndexWrap, IndexWrapM } from './style'
import { MkjkxWrap } from '../mkjkx/style'
import XwzxCarousel from './carousel'
import BannerCarousel from './carousel/banner'
import { NavLink } from 'react-router-dom'
import ZzryCarousel from './carousel/zzrySw.js'
import JxhdCarousel from './carousel/jxhdSw.js'
import { Skeleton} from 'antd'
import Slide from './carousel/newslide.jsx'
import SectionWrap from 'common/newSection'
import Axios from 'axios'

const home_title = (font) => {
  return (
    <div className="home_title">
      <i className="i_small"></i>
      <i className="i_large"></i>
      <span>{font}</span>
      <i className="i_large2"></i>
      <i className="i_small2"></i>
    </div>
  )
}
const new_title = (font, id) => {
  return (
    <NavLink className="new_title" to="/library/tzgg">
      <i className="i_small"></i>
      <i className="i_large"></i>
      {font}
      <i className="i_large"></i>
      <i className="i_small"></i>
    </NavLink>
  )
}

const new_title2 = (font, id) => {
  return (
    <NavLink className="new_title" to="/library/xwzx">
      {font}
    </NavLink>
  )
}
const mk_title = (font) => {
  return (
    <a className="home_title" href="https://www.bjsc.net.cn/recent/mengke/home">
      
      <i className="i_small"></i>
      <i className="i_large"></i>
      <span>{font}</span>
      <i className="i_large2"></i>
      <i className="i_small2"></i>
  
    
    </a>
  )
}
const zl_title = (font) => {
  return (
    <NavLink className="home_title" to="/exhibition">
      
      <i className="i_small"></i>
      <i className="i_large"></i>
      <span>{font}</span>
      <i className="i_large2"></i>
      <i className="i_small2"></i>
  
    
    </NavLink>
  )
}
const M_title = (font) => {
  return (
    <div className="m_title">
      <span>{font}</span>
      <i className="i_large2"></i>
      <i className="i_small2"></i>
    </div>
  )
}

const news_pic = (url, font, id,istop,item) => {
  let _style = {
    backgroundImage: 'url(' + url + ')',
  }
  console.log(istop)
  return (
    <div className="news_pic" style={_style}>
      {
          parseInt(istop, 10) > 0 ?
          <div className='zd'>
              <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zd.png`} alt=""/>
          </div>:''
      }
      {
        item.posts_link?
          <a className='news_pic_p_article' onClick={() => this.clickCount(item) } href={item.posts_link} target={item.posts_link.indexOf(location.host)>=0?'':'_blank'} >
            {item.post_title}
          </a>
          :
          <NavLink className="news_pic_p" to={'/article/' + id}>
            {font}
          </NavLink>
      }

    </div>
  )
}

export const title_type_2 = (font, id, icon, url) => {
  return (
    <NavLink className='title_type_2' to={(url?url:'list/')} style={{justifyContent:'flex-end'}}>
          {/*<i className='i_small'></i>*/}
          {/*<i className='i_large'></i>*/}
          {/*<i className='i_large2'></i>*/}
          {/*<i className='i_small2'></i>*/}
          {/* <div className='title-icon'>
              <img className='icon' src={'https://www.bjsc.net.cn/administrator/data/upload/portal/resource/img/library/mkjkx/'+icon+'.png'} alt="" />
              <span>{font}</span>
          </div> */}
          <div className='more' >
              <span>查看更多</span>
              <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/library/mkjkx/more.png`} alt="" />
          </div>
      </NavLink>
  )
}

export const title_type_3 = (font, id, icon, url) => {
  return (
    <a className='title_type_2' href={`${url}`}>
      <div className='more' >
        <span>查看更多</span>
        <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/library/mkjkx/more.png`} alt="" />
      </div>
    </a>
  )
}


class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      homeList: null,
      dateList: {},
      newsTab: 1,
      isBtn: true,
      isModalOpen:'none',
      mkArr: {wwmxd:[{
        term_id:''
      }],
      ssmd:[{}]},
      modelBtnImg:'',
      modelDiaImg:'',
      dcwjEWM: false
    }
  }
  initMkjkx() {
    Axios.get(`${process.env.REACT_APP_JSONBASE}/json/index_germinaceae_data.json?t=${new Date().getTime()}`).then(res=>{
      this.setState({
        mkArr: res.data,
        isLoading: false
      })
    })
  }
  openJmd(){
    window.open('http://jnh.bkweek.net')
  }
  showDcwj(s){
    this.setState({ dcwjEWM: s })
  }
  componentWillMount() {
    // document.documentElement.style.filter='grayscale(100%)'
    this.setState({isLoading: true})
    this.initMkjkx()
    this.initIndex()
    this.initTime()
    // TODO:注释3 
    this.getCalendar()
    
    document.title = '北京科学中心'
  }
  // componentWillUnmount(){
  //   document.documentElement.style.filter='none'
  // }

  initTime() {
    var myDate = new Date(),
      dateList = {},
      xqArr = [
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
        '星期日',
      ]
    dateList.year = myDate.getFullYear()
    dateList.xq = xqArr[myDate.getDay() - 1]
    dateList.date = myDate.getDate()
    dateList.month = myDate.getMonth() + 1
    this.setState({
      dateList: dateList,
    })
  }
  getCalendar(){
    Axios.get(`${process.env.REACT_APP_JSONBASE}/json/zt_getListsByTermId_566_data.json?t=${new Date().getTime()}`).then(res=>{
      this.setState({
        modelBtnImg:res.data.lists[0].smeta.photo[0].url.indexOf('www.bjsc.net.cn')==-1?`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/`+res.data.lists[0].smeta.photo[0].url:res.data.lists[0].smeta.photo[0].url,
        modelDiaImg:res.data.lists[1].smeta.photo[0].url.indexOf('www.bjsc.net.cn')==-1?`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/`+res.data.lists[1].smeta.photo[0].url:res.data.lists[1].smeta.photo[0].url
      })
    })
    
  }
  initIndex() {
    Axios.get(`${process.env.REACT_APP_JSONBASE}/json/index_inhome_data.json?t=${new Date().getTime()}`).then(res=>{
      this.setState({
        homeList: res.data
      })
    })

  }
  showModal(){
    const {isModalOpen} = this.state
    $('.modelBox').css('margin-left', -$('.modelBox').width() / 2 + 'px')
    if(isModalOpen=='none'){
      this.setState({isModalOpen:'block'})
    }else{
      this.setState({isModalOpen:'none'})
    }
    
  };
  changeNew(index) {
    this.setState({
      newsTab: index,
    })
  }
  clickCount(item) {
    React.$request({
      url:'Portal/index/storeArticleClicks',
      method:'get',
      params:{
        id:item.id
      }
    }).then(res=>{
      console.log(res)
    })
  }
  render() {
    return this.state.homeList ? (
      
      <Fragment>
        <IndexWrap>
          {/* <BannerCarousel
            className="banner"
            Carouselarr={this.state.homeList.sybn}
          /> */}

          {/* <img onClick={()=>this.openJmd()} src="/img/indexShare/hdxt.png" className='hdxtImg' alt=""/> */}
          {/* <img onMouseOver={()=>this.showDcwj(true)} onMouseOut={()=>this.showDcwj(false)} src="/img/indexShare/icon-dcwj.png" className='hdxtImg' alt=""/>
          {this.state.dcwjEWM
          ? <img src='/img/indexShare/dcwj-ewm.jpg' className='dcwjEWM' />
          : null} */}
          <Slide Carouselarr={this.state.homeList.sybn}/>
          <div className='modelBox-layer-bg' style={{display:this.state.isModalOpen}} onClick={()=>this.showModal()}></div>
          <div className='modelBox' style={{display:this.state.isModalOpen}}>
            <svg t="1667786901653" onClick={()=>this.showModal()} class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2528" width="200" height="200"><path d="M576 512l277.333333 277.333333-64 64-277.333333-277.333333L234.666667 853.333333 170.666667 789.333333l277.333333-277.333333L170.666667 234.666667 234.666667 170.666667l277.333333 277.333333L789.333333 170.666667 853.333333 234.666667 576 512z" fill="#444444" p-id="2529"></path></svg>
             {/* TODO:注释2 */}
            <img src={this.state.modelDiaImg} />
          </div>

          <div className="mb">
            <div className="index_part_2">
            <div className="today_part">
              <div className="title">
                {this.state.dateList.year}-
                {this.state.dateList.month >= 10
                  ? this.state.dateList.month
                  : '0' + this.state.dateList.month}-{this.state.dateList.date>=10?this.state.dateList.date:'0'+this.state.dateList.date}
                <span style={{'marginLeft':'10px'}}>{this.state.dateList.xq}</span>
                
              </div>
              <div className="today_p_bot" style={{marginTop:'20px'}}>
                <a href={this.state.homeList.hdtp[0].posts_link}>
                  <img src={this.state.homeList.hdtp[0].path} alt="" />
                </a>
                <div className="font">
                  {/* TODO:注释1 */}
                  <img src={this.state.modelBtnImg} onClick={()=>this.showModal()} style={{width:'200px',marginRight:'20px',cursor:'pointer'}} alt="" />
                  {/* <div className="date">{this.state.dateList.date}</div>
                  <div className="xq">{this.state.dateList.xq}</div> */}
                </div>
              </div>
            </div>
            
            <div className="schedule">
              <div className="schedule_list">
                <div className="zcg">
                  <div className="left_title">
                    主<br />展<br />馆
                  </div>
                  <div className="right_time">
                    <span className="top_span">09:30-17:00</span>
                    <span className="addspan">16:00停止入场</span>
                  </div>
                </div>
                <div className="etly">
                  <div className="left_title">
                    儿<br />童<br />乐<br />园
                  </div>
                  <div className="right_time">
                    <span className="top_span">上午&nbsp;09:30-12:30 </span>
                    <span className="addspan">12:00停止检票</span>
                    <span className="top_span">下午&nbsp;13:30-16:30</span>
                    <span className="addspan">16:00停止检票</span>
                  </div>
                </div>
                <div className="schedule_time">
                  <span className="top_span top_span1">
                    <i>
                      <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/icon_clock_03.png`} alt="" />
                    </i>
                    &nbsp;&nbsp;周三至周日开馆
                  </span>
                  {/* <NavLink to={'/article/1055'} className="link">
                    详情&#62;&#62;
                  </NavLink> */}
                  <NavLink to={'/service'} className="link">
                    详情&#62;&#62;
                  </NavLink>
                </div>
              </div>
              {/* <div className="schedule_bot">
                                <div className='line_1'>主场馆：周三至周日<br/>9:30－12:00，13:00－17:00。
                                <br/>儿童乐园：周三至周日<br/>9:30－12:00，13:30－16:00。<NavLink to={'/article/1055'}>
                                    详情
                                </NavLink>
                                </div>
                            </div> */}
            </div>
            <div className="address">
              <div className="top">
                <h2>北京科学中心</h2>
                <h3>中国北京市西城区北辰路9号院</h3>
              </div>
              <div className="line">
                <div className="line_section">
                  <div className="title">
                    <i>
                      <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/index_12.png`} alt="" />
                    </i>
                    <span>地铁线路</span>
                  </div>
                  <div className="detail">
                    地铁8号线安华桥站，B口出站即可到达。
                  </div>
                </div>
                <div className="line_section">
                  <div className="title">
                    <i>
                      <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/index_09.png`} alt="" />
                    </i>
                    <span>公交线路</span>
                  </div>
                  <div className="detail">
                    公交113路、21路、409路、607路安华桥北站下车...{' '}
                    <NavLink to="/article/1353">详细</NavLink>
                  </div>
                </div>
              </div>
              <div className="links">
                <a
                  href="//ticket.bjsc.net.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
              <svg t="1612749741584" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2995" width="64" height="64"><path d="M995.677124 830.496905 995.677124 830.52915 995.677124 830.52915 995.677124 927.264575 995.677124 927.264575 995.677124 959.477472C995.677124 995.108353 966.785477 1023.967755 931.18684 1023.967755L92.81316 1023.967755C57.214523 1023.967755 28.322876 995.140598 28.322876 959.509716L28.322876 959.509716 28.322876 959.509716C28.322876 959.477472 28.322876 959.477472 28.322876 959.477472L28.322876 894.987189 28.322876 894.987189 28.322876 894.987189C28.322876 894.987189 28.322876 894.987189 28.322876 894.987189L28.322876 830.496905C99.552394 830.496905 157.303442 772.778102 157.303442 701.548584 157.303442 630.383557 99.681374 572.696998 28.580838 572.568017L28.322876 572.568017 28.322876 572.535773C28.322876 572.535773 28.322876 572.535773 28.322876 572.535773L28.322876 508.045489C28.322876 508.045489 28.322876 508.045489 28.322876 508.045489L28.322876 508.045489 28.322876 508.045489 28.322876 443.555206C28.322876 431.656749 31.773106 420.661156 37.383761 411.116594 38.834792 393.639727 47.47649 377.033479 63.728041 367.617898L684.543753 7.439666C710.920278-7.876776 744.648696 1.216354 759.868404 27.72186L787.438 75.702631 764.73742 88.890893 769.219494 88.890893C775.120356 84.312083 780.827746 79.572048 787.438 75.702631L815.007596 123.683402C762.286789 154.316286 744.197264 222.063328 774.636678 275.074341 805.108337 328.085355 872.565173 346.239369 925.318225 315.63873L952.887821 363.619501C945.826135 367.714633 938.538733 370.874657 931.18684 373.647739L931.18684 376.195105 952.887821 363.619501 968.849166 391.414813C985.036227 403.119799 995.677124 422.047697 995.677124 443.555206L995.677124 475.832593 995.677124 475.832593 995.677124 572.568017 995.419162 572.568017C924.318626 572.696998 866.696558 630.383557 866.696558 701.548584 866.696558 772.778102 924.447606 830.496905 995.677124 830.496905ZM726.881624 302.772918C692.798509 243.409612 699.344273 171.760908 737.715991 120.136436L737.715991 99.983223 712.113349 55.420437 154.240154 379.064923 824.294196 379.064923C784.664917 367.553407 749.163016 341.499333 726.881624 302.772918ZM931.18684 519.911701 931.18684 508.045489 931.18684 508.045489 931.18684 443.555206 92.81316 443.555206 92.81316 443.587451 92.81316 443.587451 92.81316 519.911701C167.783114 546.546189 221.793726 617.421009 221.793726 701.548584 221.793726 785.643913 167.783114 856.518734 92.81316 883.153222L92.81316 959.477472 931.18684 959.477472 931.18684 894.987189 931.18684 894.987189 931.18684 883.153222C856.216886 856.518734 802.206274 785.643913 802.206274 701.548584 802.206274 617.421009 856.216886 546.546189 931.18684 519.911701ZM528.122571 862.774292 495.877429 862.774292C486.97777 862.774292 479.754859 855.519135 479.754859 846.619476L479.754859 814.374334C479.754859 805.474676 486.97777 798.251764 495.877429 798.251764L528.122571 798.251764C537.02223 798.251764 544.245141 805.474676 544.245141 814.374334L544.245141 846.619476C544.245141 855.519135 537.02223 862.774292 528.122571 862.774292ZM528.122571 733.76148 495.877429 733.76148C486.97777 733.76148 479.754859 726.538569 479.754859 717.63891L479.754859 685.393768C479.754859 676.494109 486.97777 669.271198 495.877429 669.271198L528.122571 669.271198C537.02223 669.271198 544.245141 676.494109 544.245141 685.393768L544.245141 717.63891C544.245141 726.538569 537.02223 733.76148 528.122571 733.76148ZM528.122571 604.780914 495.877429 604.780914C486.97777 604.780914 479.754859 597.558002 479.754859 588.658344L479.754859 556.413202C479.754859 547.513543 486.97777 540.290631 495.877429 540.290631L528.122571 540.290631C537.02223 540.290631 544.245141 547.513543 544.245141 556.413202L544.245141 588.658344C544.245141 597.558002 537.02223 604.780914 528.122571 604.780914ZM431.129184 314.413415 455.022834 300.548003C461.600844 296.743076 470.016826 299.000236 473.853997 305.642736L487.622672 329.600876C491.4276 336.243375 489.17044 344.723847 482.592431 348.561019L458.698781 362.394184C452.120772 366.231357 443.672545 363.941952 439.867619 357.331698L426.098942 333.341313C422.261771 326.698813 424.551176 318.250586 431.129184 314.413415Z" p-id="2996" fill="#ffffff"></path></svg>
              门票预约
                </a>
                <a
                  href="//ticket.bjsc.net.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                    {/* <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/index_17.png" alt="" /> */}
                    <svg t="1612750003577" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3874" width="64" height="64"><path d="M861.622857 382.639543a29.257143 29.257143 0 0 0-22.2208-20.2752L567.003429 307.229257l8.704-42.978743a29.257143 29.257143 0 0 0-22.879086-34.464914l-267.585829-54.140343a72.791771 72.791771 0 0 0 22.176915-52.341028c0-40.404114-32.738743-73.142857-73.142858-73.142858s-74.049829 32.738743-74.049828 73.142858a73.435429 73.435429 0 0 0 23.844571 54.462171v766.7712a29.257143 29.257143 0 0 0 58.514286 0v-432.274286l213.869714 41.6768-8.177371 42.642286c-1.536 7.606857 0.219429 15.345371 4.5056 21.796571a28.964571 28.964571 0 0 0 18.695314 12.112458l301.1584 63.341714c1.930971 0.394971 3.935086 2.223543 5.851429 2.223543h0.292571c16.164571 0 29.257143-14.774857 29.257143-30.910172 0-4.885943-1.184914-9.567086-3.291429-13.604571l-49.517714-140.3904 99.0208-99.006172a29.842286 29.842286 0 0 0 7.3728-29.505828z m-608.007314 72.001828c-3.452343-0.672914-11.029943-0.6144-11.029943-0.1024V227.079314l269.063314 54.242743-8.235885 42.920229h0.219428L468.406857 496.596114l-214.791314-41.954743z m447.224686 27.355429a29.257143 29.257143 0 0 0-6.933943 30.5152l39.745828 112.054857-221.769143-44.8512 43.52-215.083886 218.843429 44.280686-73.406171 73.084343z" fill="#ffffff" p-id="3875"></path><path d="M441.943771 313.782857l-146.285714-29.257143a14.628571 14.628571 0 0 0-5.749028 28.686629l146.285714 29.257143a14.599314 14.599314 0 0 0 17.2032-11.4688 14.599314 14.599314 0 0 0-11.454172-17.217829zM596.8896 444.8256l44.309943 9.596343a14.6432 14.6432 0 0 0 6.202514-28.598857l-44.309943-9.596343a14.672457 14.672457 0 0 0-17.393371 11.205486 14.613943 14.613943 0 0 0 11.190857 17.393371z" fill="#ffffff" p-id="3876"></path></svg>
              活动报名
                </a>
              </div>
            </div>
            </div>
            <div className="news_wrap">
            <div className="news_content">
              <div className="hdyg">
                {new_title(
                  '活动预告',
                  this.state.homeList.hdyg.list[0].term_id
                )}
                <div className="hdyg_list">
                  {news_pic(
                    this.state.homeList.hdyg.list[0].path,
                    this.state.homeList.hdyg.list[0].post_title,
                    this.state.homeList.hdyg.list[0].id,
                    this.state.homeList.hdyg.list[0].istop,
                    this.state.homeList.hdyg.list[0],
                  )}
                  {this.state.homeList.hdyg.list.map((item, index) => {
                    if (index >= 1) {
                      return (
                          item.posts_link?
                              <a className='hdyg_a_article' onClick={() => this.clickCount(item) } href={item.posts_link} target={item.posts_link.indexOf(location.host)>=0?'':'_blank'} >
                                {item.post_title}
                              </a>
                              :
                            <NavLink
                              to={'/article/' + item.id}
                              className="hdyg_link"
                              key={item.id}
                              title={item.post_title}
                            >
                              {/* <div className="time">
                                                                <div className='day'>{item.post_date.split('/')[2]}</div>
                                                                <div className='year'>{item.post_date.split('/')[0]}.{item.post_date.split('/')[1]}</div>
                                                            </div> */}
                              <div className="article">{item.post_title}</div>
                            </NavLink>
                      )
                    } else {
                      return null
                    }
                  })}
                  {/* <NavLink className='more' to={'/list/'+this.state.homeList.hdyg[0].term_id}>更多</NavLink> */}
                  <NavLink className="more" to="/library/tzgg">
                    更多
                  </NavLink>
                </div>
              </div>
              <div className="xwzx">
                {new_title2('新闻资讯', this.state.homeList.xwzxwz[0].term_id)}
                <div className="hdyg_list">
                  {news_pic(
                    this.state.homeList.xwzxwz[0].path,
                    this.state.homeList.xwzxwz[0].post_title,
                    this.state.homeList.xwzxwz[0].id,
                    this.state.homeList.xwzxwz[0].istop,
                    this.state.homeList.xwzxwz[0],
                  )}
                  {this.state.homeList.xwzxwz.map((item, index) => {
                    if (index >= 1) {
                      return (
                            item.posts_link?
                            <a className='hdyg_a_article' onClick={() => this.clickCount(item) } href={item.posts_link} target={item.posts_link.indexOf(location.host)>=0?'':'_blank'} >
                              {item.post_title}
                            </a>
                            :
                            <NavLink to={'/article/' + item.id} className="hdyg_link" key={item.id} title={item.post_title}>
                              <div className="article">{item.post_title}</div>
                            </NavLink>
                      )
                    }
                  })}
                  <NavLink className="more" to="/library/xwzx">
                    更多
                  </NavLink>
                </div>
              </div>

              <div className="tzgg">
                {new_title(
                  '通知公告',
                  this.state.homeList.tzgg.list[0].term_id
                )}
                <div className="tzgg_list">
                  {this.state.homeList.tzgg.list.map((item) => {
                    return (
                        item.posts_link?
                            <a className='tzgg_link' onClick={() => this.clickCount(item) } href={item.posts_link} target={item.posts_link.indexOf(location.host)>=0?'':'_blank'} >
                              {
                                parseInt(item.istop, 10) > 0 ?
                                    <span className='zd'>
                                      <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt=""/>
                                    </span> : ""
                              }
                              {item.post_title}
                            </a>
                            :
                      <NavLink
                        to={'/article/' + item.id}
                        className="tzgg_link"
                        key={item.id}
                        title={item.post_title}
                      >
                        {
                          parseInt(item.istop, 10) > 0 ?
                            <span className='zd'>
                              <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt=""/>
                            </span> :
                            ""
                        }
                        {item.post_title}
                      </NavLink>
                    )
                  })}
                  <NavLink className="more" to="/library/tzgg">
                    更多
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div className="mb">
            {home_title('正在热映')}
            <div className="zzry">
              <ZzryCarousel
                Carouselarr={this.state.homeList.yyry}
                className="zzry_sw"
              />
            </div>
            <div className="zzry_ttyy_link">
              <a href="/#/article/18213">点此预约</a>
            </div>
          </div>

          <div className="mb">
            {home_title('精选活动')}
            <div className="jxhd">

              <JxhdCarousel
                Carouselarr={this.state.homeList.jxhd}
                className="jxhd_sw"
              />
            </div>
          </div>
          {/* <div className="yyry">
            <a className="yyry_img" href="//www.bjsc.net.cn/#/xsdll">
                <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20220921/632ad2f00845b.png`} alt="" />
            </a>
          </div> */}
          <div className="mb">
          <div className="zltj">
            {zl_title('展览推荐')}
            <div className="zltj_list">
              <NavLink
                className="zltj_tab"
                to={'/exhibition/zzt'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20190820/5d5bb0c13a6e9.jpg)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title">主展馆</div>
                  </div>
                </div>
              </NavLink>
              <NavLink
                className="zltj_tab"
                to={'/exhibition/etly'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20190820/5d5bb3002a69a.jpg)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title">儿童乐园</div>
                  </div>
                </div>
              </NavLink>
              <a
                className="zltj_tab"
                href={'//www.bjsc.net.cn/zt/kxjztz/#/'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zltj-img02.jpg)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title" style={{fontSize: '16px'}}>众心向党 自立自强<br/>—“党领导下的科学家”主题展</div>
                  </div>
                </div>
              </a>
              <NavLink
                className="zltj_tab"
                to={'/list/52'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20210402/6066bd0aec2fe.png)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title">短期展</div>
                  </div>
                </div>
              </NavLink>
            </div>
          </div>
          
          <MkjkxWrap>
          {/*TODO: this.state.mkArr 所有v2子集所有v2删除 */}
            <div style={{position:'relative'}}>
              {/* {home_title('萌科讲科学' )} */}
              {mk_title('萌科讲科学' )}
              {/* <div style={{position:'absolute',right:'0',top:'-58px'}}>{title_type_3('萌科讲科学', this.state.mkArr.wwmxdv2[0].term_id, 'wwmxdv2', 'https://www.bjsc.net.cn/recent/mengke')}</div> */}
            </div>
          
            <div className="mtbd">
                <div className="mtbd_wrap">
                    {/*<SectionWrap secarr={item} key={item.id}/>*/}
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.wwmxdv2.map((item) => {
                          return (
                              <div key={item.id} className='hdbd_section'>
                                  <div className="hdbd_section_img_wrap">
                                      <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=0`}>
                                        <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                        <div className="tag">万万没想到</div>
                                      </a>
                                  </div>
                                  <div className="hdbd_section_detail">
                                    <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=0`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                    <div className='hdbd_section_date'>{item.post_date}</div>
                                  </div>
                              </div>
                          )
                        })
                      )
                    }
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.ssmdv2.map((item) => {
                          return (
                            <div key={item.id} className='hdbd_section'>
                              <div className="hdbd_section_img_wrap">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=2`}>
                                  <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                  <div className="tag">30秒懂</div>
                                </a>
                              </div>
                              <div className="hdbd_section_detail">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=2`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                <div className='hdbd_section_date'>{item.post_date}</div>
                              </div>
                            </div>
                          )
                        })
                      )
                    }
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.kdkxcdv2.map((item) => {
                          return (
                                <div key={item.id} className='hdbd_section'>
                                <div className="hdbd_section_img_wrap">
                                  <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=1`}>
                                    <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                    <div className="tag">口袋科学辞典</div>
                                  </a>
                                </div>
                                <div className="hdbd_section_detail">
                                <a className='hdbd_section_detail_title' href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=1`}>{item.post_title}</a>
                                  <div className='hdbd_section_date'>{item.post_date}</div>
                                </div>
                            </div>
                          )
                        })
                      )
                    }
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.xgssv2.map((item) => {
                          return (
                            <div key={item.id} className='hdbd_section'>
                              <div className="hdbd_section_img_wrap">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}`}>
                                  <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                  <div className="tag">星光闪闪</div>
                                </a>
                              </div>
                              <div className="hdbd_section_detail">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                <div className='hdbd_section_date'>{item.post_date}</div>
                              </div>
                            </div>
                          )
                        })
                      )
                    }
                </div>
            </div>
            </MkjkxWrap>
          {/* <div className="yyry">
            {home_title('影院热映')}
            <div className="yyry_img">
              <img src={this.state.homeList.yyry[0].path} alt="" />
            </div>
          </div> */}
          {/* <div className="yyry">
           {home_title('萌科讲科学')} 
            <NavLink className="yyry_img" to="/mkjkx">
              <img src={this.state.homeList.mkjkx[0].path} alt="" />
            </NavLink>
          </div> */}
          
          {/* <div className="footer_link">
            <NavLink className="footer_link_tab" to="/library">
              关于中心
            </NavLink>
            <NavLink className="footer_link_tab" to="/zxfk">
              在线反馈
            </NavLink>
            <NavLink className="footer_link_tab" to="/zyz">
              志愿者招募
            </NavLink>
            <NavLink className="footer_link_tab" to="/train">
              科普培训
            </NavLink>
          </div> */}
          <div className="yqlj">
            <div className="yqlj_title">【友情链接】</div>
            <div className="yqlj_list">
              {this.state.homeList.yqlj.map((item) => {
                return (
                  <a
                    className="yqlj_link"
                    key={item.link_id}
                    href={item.link_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.link_name}
                  </a>
                )
              })}
            </div>
          </div>
          </div>
        </IndexWrap>
        <IndexWrapM>
          <BannerCarousel
            className="banner"
            Carouselarr={this.state.homeList.sybn}
          />
          {/* <img src="/img/indexShare/hdxt1.png" className='hdxt1' onClick={()=>this.openJmd()}/> */}
          {/* {M_title('参观指南')} */}
          <div className="index_part_2">
            <div className="today_part">
              <div className="title">
                {this.state.dateList.year}-
                {this.state.dateList.month >= 10
                  ? this.state.dateList.month
                  : '0' + this.state.dateList.month}
                -{this.state.dateList.date} {this.state.dateList.xq}
              </div>
              <div className="today_p_bot">
                <a href={this.state.homeList.hdtp[0].posts_link}>
                  <img src={this.state.homeList.hdtp[0].path} alt="" />
                </a>
                {/* <div className="font">
                                        <div className='date'>{this.state.dateList.date}</div>
                                        <div className='xq'>{this.state.dateList.xq}</div>
                                    </div> */}
              </div>
            </div>
            <div className="schedule">
              <div className="schedule_list">
                <div className="zcg">
                  <div className="left_title">
                    主<br />展<br />馆
                  </div>
                  <div className="right_time">
                    <span className="top_span ">09:30-17:00</span>
                    <span className="red_span red_span1">16:00停止入场</span>
                  </div>
                </div>
                <div className="etly">
                  <div className="left_title">
                    儿<br />童<br />乐<br />园
                  </div>
                  <div className="right_time">
                    <span className="top_span ">上午&nbsp;09:30-12:30 </span>
                    <span className="red_span red_span1">
                      下午&nbsp;13:30-16:30
                    </span>
                  </div>
                </div>
                <span className="top_span top_span1">
                  <i>
                    <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/icon_clock_03.png`} alt="" />
                  </i>
                  &nbsp;&nbsp;周三至周日开馆
                </span>
                <NavLink to={'/service'} className="link">
                  详情&#62;&#62;
                </NavLink>
              </div>
            </div>
          </div>

          <div className="address">
            <div className="top">
              <h2>北京科学中心</h2>
              <h3>中国北京市西城区北辰路9号院</h3>
            </div>
            <div className="line">
              <div className="line_section">
                <div className="title">
                  <i>
                    <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/index_12.png`} alt="" />
                  </i>
                  <span>地铁线路</span>
                </div>
                <div className="detail">
                  地铁8号线安华桥站，B口出站即可到达。
                </div>
              </div>
              <div className="line_section">
                <div className="title">
                  <i>
                    <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/index_09.png`} alt="" />
                  </i>
                  <span>公交线路</span>
                </div>
                <div className="detail">
                  公交113路、21路、409路、607路安华桥北站下车...{' '}
                  <NavLink to="/article/1353">详细</NavLink>
                </div>
              </div>
            </div>
            {/* <div className="links">
                                <a href={this.state.homeList.kxzxan[0].posts_link}>
                                    <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/link_03.png" alt=""/>
                                </a>
                                <a href={this.state.homeList.kxzxan[1].posts_link}>
                                    <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/link_05.png" alt=""/>
                                </a>
                            </div> */}
          </div>

          <div className="news_wrap">
            <div className="news_content">
              <div className="news_part_1">
                <div className="news_part_1_tab">
                  <div
                    className={
                      this.state.newsTab === 1
                        ? 'news_tab_1 news_tab_1_active'
                        : 'news_tab_1'
                    }
                    onClick={() => this.changeNew(1)}
                  >
                    活动预告
                  </div>
                  <div
                    className={
                      this.state.newsTab === 2
                        ? 'news_tab_2 news_tab_2_active'
                        : 'news_tab_2'
                    }
                    onClick={() => this.changeNew(2)}
                  >
                    通知公告
                  </div>
                </div>
                {this.state.newsTab === 1 ? (
                  <div className="hdyg">
                    <div className="hdyg_list">
                      {this.state.homeList.hdyg.list.map((item) => {
                        return (
                            item.posts_link?
                                <a className='hdyg_link' onClick={() => this.clickCount(item) } href={item.posts_link} target={item.posts_link.indexOf(location.host)>=0?'':'_blank'} >
                                  <div className="article">
                                    <i></i>
                                    {
                                      parseInt(item.istop, 10) > 0 ?
                                          <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt=""/> :
                                          ""
                                    }
                                    <span>{item.post_title}</span>
                                  </div>
                                  <div className="time">
                                    <div className="year">
                                      {item.post_date.split('/')[0]}/
                                      {item.post_date.split('/')[1]}/
                                      {item.post_date.split('/')[2]}
                                    </div>
                                  </div>
                                </a>
                                  :
                          <NavLink
                            to={'/article/' + item.id}
                            className="hdyg_link"
                            key={item.id}
                          >
                            <div className="article">
                              <i></i>
                              {
                                parseInt(item.istop, 10) > 0 ?
                                  <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt=""/> :
                                  ""
                              }
                              <span>{item.post_title}</span>
                            </div>
                            <div className="time">
                              <div className="year">
                                {item.post_date.split('/')[0]}/
                                {item.post_date.split('/')[1]}/
                                {item.post_date.split('/')[2]}
                              </div>
                            </div>
                          </NavLink>
                        )
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="tzgg">
                    <div className="tzgg_list">
                      {this.state.homeList.tzgg.list.map((item) => {
                        return (
                            item.posts_link?
                                <a className='hdyg_link' onClick={() => this.clickCount(item) } href={item.posts_link} target={item.posts_link.indexOf(location.host)>=0?'':'_blank'} >
                                  <div className="article">
                                    <i></i>
                                    {
                                      parseInt(item.istop, 10) > 0 ?
                                          <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt=""/> :
                                          ""
                                    }
                                    <span>{item.post_title}</span>
                                  </div>
                                  <div className="time">
                                    <div className="year">
                                      {item.post_date.split('/')[0]}/
                                      {item.post_date.split('/')[1]}/
                                      {item.post_date.split('/')[2]}
                                    </div>
                                  </div>
                                </a>
                                  :
                              <NavLink
                                to={'/article/' + item.id}
                                className="hdyg_link"
                                key={item.id}
                              >
                                <div className="article">
                                  <i></i>
                                  {
                                    parseInt(item.istop, 10) > 0 ?
                                      <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt=""/> :
                                      ""
                                  }
                                  <span>{item.post_title}</span>
                                </div>
                                <div className="time">
                                  <div className="year">
                                    {item.post_date.split('/')[0]}/
                                    {item.post_date.split('/')[1]}/
                                    {item.post_date.split('/')[2]}
                                  </div>
                                </div>
                              </NavLink>
                        )
                      })}
                    </div>
                  </div>
                )}
              </div>
              <div className="xwzx">
                {M_title('新闻资讯')}
                <div className="xwzx_list">
                  {this.state.homeList.xwzxwz.map((item) => {
                    return <SectionWrap secarr={item} key={item.id} />
                  })}
                </div>
              </div>
            </div>
          </div>
         
          {M_title('正在热映')}
          <div className="zzry">
            {
              <XwzxCarousel
                className="sw"
                Carouselarr={this.state.homeList.yyry}
                isBtn={true}
              />
            }
          </div>
          <div className="zzry_ttyy_link">
            <a href="/#/article/18213">点此预约</a>
          </div>

          {M_title('精选活动')}
          <div className="jxhd">
            {
              <XwzxCarousel
                className="sw"
                Carouselarr={this.state.homeList.jxhd}
                isBtn={true}
              />
            }
          </div>
          
          {/* <div className="yyry" style={{marginTop:'2vw'}}>
              {home_title('向上的力量')}
              <a className="yyry_img" href={this.state.homeList.tylm[0].posts_link}>
                <img src={this.state.homeList.tylm[0].path} alt="" />
              </a>
          </div> */}
          {M_title('展览推荐')}
          <div className="zltj">
            <div className="zltj_list">
              <NavLink
                className="zltj_tab"
                to={'/exhibition/zzt'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20190820/5d5bb0c13a6e9.jpg)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title">主展馆</div>
                  </div>
                </div>
              </NavLink>
              <NavLink
                className="zltj_tab"
                to={'/exhibition/etly'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20190820/5d5bb3002a69a.jpg)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title">儿童乐园</div>
                  </div>
                </div>
              </NavLink>
              <a
                className="zltj_tab"
                href={'//www.bjsc.net.cn/zt/kxjztz/#/'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zltj-img02.jpg)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title" style={{fontSize: '0.15rem'}}>众心向党 自立自强<br/>—“党领导下的科学家”主题展</div>
                  </div>
                </div>
              </a>
              <NavLink
                className="zltj_tab"
                to={'/list/52'}
                style= {{backgroundImage: `url(${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/20210402/6066bd0aec2fe.png)`}}
              >
                <div className="zltjMask">
                  <div className="zltj_content">
                    <img src="" alt="" />
                    <div className="zltj_title">短期展</div>
                  </div>
                </div>
              </NavLink>
            </div>
          </div>
          {/* {M_title('影院热映')}
          <div className="yyry">
            <div className="yyry_img">
              <img src={this.state.homeList.yyry[0].path} alt="" />
            </div>
          </div> */}
          {M_title('萌科讲科学')}
          <MkjkxWrap>
          {/* {title_type_2('原创科普文章', this.state.mkArr.wwmxd[0].term_id, 'wwmxd','/listtab2/')} */}
            <div className="mtbd">
                <div className="mtbd_wrap">
                    {/*<SectionWrap secarr={item} key={item.id}/>*/}
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.wwmxdv2.map((item) => {
                          return (
                            <div key={item.id} className='hdbd_section'>
                              <div className="hdbd_section_img_wrap">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=0`}>
                                  <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                  <div className="tag">万万没想到</div>
                                </a>
                              </div>
                              <div className="hdbd_section_detail">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=0`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                <div className='hdbd_section_date'>{item.post_date}</div>
                              </div>
                            </div>
                          )
                        })
                      )
                    }
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.ssmdv2.slice(0, 2).map((item) => {
                          return (
                            <div key={item.id} className='hdbd_section'>
                              <div className="hdbd_section_img_wrap">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=2`}>
                                  <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                  <div className="tag">30秒懂</div>
                                </a>
                              </div>
                              <div className="hdbd_section_detail">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=2`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                <div className='hdbd_section_date'>{item.post_date}</div>
                              </div>
                            </div>
                          )
                        })
                      )
                    }
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.kdkxcdv2.map((item) => {
                          return (
                            <div key={item.id} className='hdbd_section'>
                              <div className="hdbd_section_img_wrap">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=1`}>
                                  <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                  <div className="tag">
                                    口袋科学辞典
                                  </div>
                                </a>
                              </div>
                              <div className="hdbd_section_detail">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}&index=1`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                <div className='hdbd_section_date'>{item.post_date}</div>
                              </div>
                            </div>
                          )
                        })
                      )
                    }
                    {
                      this.state.isLoading ? '加载中...' : (
                        this.state.mkArr.xgssv2.map((item) => {
                          return (
                            <div key={item.id} className='hdbd_section'>
                              <div className="hdbd_section_img_wrap">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}`}>
                                  <img src={item.path?item.path:`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/logodemo_02.jpg`} alt=""/>
                                  <div className="tag">星光闪闪</div>
                                </a>
                              </div>
                              <div className="hdbd_section_detail">
                                <a href={`/recent/mengke/detail?type=Article&term_id=${item.term_id}&id=${item.id}`} className='hdbd_section_detail_title'>{item.post_title}</a>
                                <div className='hdbd_section_date'>{item.post_date}</div>
                              </div>
                            </div>
                          )
                        })
                      )
                    }
                </div>
            </div>
            </MkjkxWrap>
          {/* <NavLink className="yyry" to={'/mkjkx'}>
            <div className="yyry_img">
              <img src={this.state.homeList.mkjkx[0].path} alt="" />
            </div>
          </NavLink> */}
          {/* <div className="footer_link">
            <NavLink className="footer_link_tab" to="/library">
              关于中心
            </NavLink>
            <NavLink className="footer_link_tab" to="/zxfk">
              在线反馈
            </NavLink>
            <NavLink className="footer_link_tab" to="/zyz">
              志愿者招募
            </NavLink>
            <NavLink className="footer_link_tab" to="/train">
              科普培训
            </NavLink>
          </div> */}
          <div className="yqlj">
            <div className="yqlj_title">【友情链接】</div>
            <div className="yqlj_list">
              {this.state.homeList.yqlj.map((item) => {
                return (
                  <a
                    className="yqlj_link"
                    key={item.link_id}
                    href={item.link_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.link_name}
                  </a>
                )
              })}
            </div>
          </div>
        </IndexWrapM>
      </Fragment>
    ) : (
      <Skeleton active />
    )
  }
}

export default Home
